<template>
  <!-- 
    * Title: 异常提示页
    * Route: /crash
  -->
  <div class="main">
    <div class="content">
      <div class="logo-module">
          <img class="logo-img" src="@/assets/img/modal-logo.png" alt="">
      </div>
      <div class="tips-module">
        <div class="tips-text">
          The transaction is complete, please return to the merchant to view the results.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .main {
    position: relative;
    width: 375px;
    margin: 0 auto;
    background: #eef4f8;
    height: 680px;
    margin: 0 auto;
    background-color: #ffffff;
    .content {
      position: absolute;
      top: 30%;
      transform: translateY(-30%);
      .logo-module {
        .logo-img {
          display: block;
          width: 90px;
          height: 90px;
          margin: 0 auto;
        }
      }
      .tips-module {
        .tips-text {
          text-align: center;
          padding: 30px;
          color: #8497a4;
          margin: 0 auto;
        }
      }
    }
  }
</style>